export default {
  state: {
    siteList: [
      { id: 'kasinohai', name: 'Kasinohai', market: 'fi' },
      { id: 'casinobernie', name: 'CasinoBernie', market: 'all' },
      { id: 'casinovibez', name: 'CasinoVibez', market: 'us' },
      { id: 'casinokokemus', name: 'CasinoKokemus', market: 'fi' },
      { id: 'uusimmatkasinot', name: 'Uusimmatkasinot', market: 'fi' },
      { id: 'bogdancazino', name: 'Bogdancazino', market: 'ro' },
    ],
  },
  getters: {
    siteList(state) {
      return state.siteList
    },
    siteById: state => siteId => {
      return state.siteList.find(state => state.id === siteId)
    },
  },
}
